import React, { memo } from 'react';
import { useSelector } from 'react-redux';

function FrameRateIndicator({ participantJid }) {
  const attendeesFrameRate = useSelector(
    state => state.conf.attendeesFrameRate,
  );

  const frameRate = (() => {
    if (!participantJid || !attendeesFrameRate || !attendeesFrameRate[participantJid]) {
      return null;
    }
    const trackFrameRates = attendeesFrameRate[participantJid];
    // Get the first framerate value from the nested object
    const values = Object.values(trackFrameRates);
    return values.length > 0 ? values[0] : null;
  })();
  if (!frameRate) return null;

  return (
    <div
      style={{
        position: 'absolute',
        top: '8px',
        right: '8px',
        backgroundColor: 'rgba(0, 0, 0, 0.6)',
        color: '#fff',
        padding: '2px 6px',
        borderRadius: '4px',
        fontSize: '12px',
        fontWeight: '500',
        zIndex: 10,
      }}
    >
      {frameRate} FPS
    </div>
  );
}

export default memo(FrameRateIndicator);
